import React from 'react'
// import css from './styles.js'
import { _Submit } from './styles'

const HiddenSubmit = () => <_Submit type="submit" />

HiddenSubmit.propTypes = {}

export default HiddenSubmit
